/*
	Initialize the global settings for the APIs
*/
export {imageAPI} from './apis/imageAPI'
export {imageArchive} from './apis/imageArchive'
export {reportAPI} from './apis/reportAPI'
export {userStoreAPI} from './apis/userStoreAPI'
export {columbiaAPI} from './apis/columbiaAPI'
export { getBaselineJWT } from './apis/libJWT'
export {FetchError} from './apis/fetchError'

export { apiEndpointEnum } from './apis/enums/apiEndpoints'
export { baseURLEnum } from './apis/enums/baseURL';
export { signOutApp, getCurrentAuthenticatedUser } from './apis/auth';

export var apiConfiguration = null;
export var logger = null;

import {configureAmplify} from './apis/amplify';
export {configureAmplify} from './apis/amplify';
export {Auth} from 'aws-amplify';

export function initApiConfiguration(
	region,
	userPoolId,
	userPoolWebClientId,
	baseurls,
	_logger
)
{
	if (apiConfiguration == null)
	{
		apiConfiguration = new Object();
	}

	apiConfiguration.region = region;
	apiConfiguration.userPoolId = userPoolId
	apiConfiguration.userPoolWebClientId = userPoolWebClientId;
	apiConfiguration.baseurls=baseurls;
	logger = _logger;

	localStorage.setItem('baselineAPIConfiguration', JSON.stringify(apiConfiguration));

	configureAmplify();
}

export function getLogger()
{
	return logger;
}

export function getApiConfiguration()
{
	if (apiConfiguration != null)
	{
		return apiConfiguration;
	}
	apiConfiguration = localStorage.getItem('baselineAPIConfiguration');
	apiConfiguration = JSON.parse(apiConfiguration);
	return apiConfiguration;
}

export function getAmplifyConfiguration()
{
	const configuration = getApiConfiguration();
	const result = {
		region: configuration.region,
		userPoolId: configuration.userPoolId,
		userPoolWebClientId: configuration.userPoolWebClientId
	}
	return result;
}

export function baseURL(key)
{
	const configuration = getApiConfiguration();
	return configuration.baseurls[key];
}
